import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/baseNumeric.scss';
export const NumericSeparator = () => {
    return _jsx("span", { className: "numeric-separator", "aria-hidden": "true" });
};
